import moment from "moment";
export const filter = {
    staff_id:'',
    date: '',  
    branch_id:'',
    time: moment().format("HH:mm:ss"),  
}
